import { computed } from "vue";
import StringUtils from "@utils/string.utils.ts";
import { useDynamicLinkStore } from "@plugins/dynamic-link/dynamic.link.store.ts";
import {
  ACTIVITY_ICON_NAME,
  LESSON_ACTIVITY_TYPE,
} from "@plugins/common/constant/resource.constant.ts";
import { LESSON_ACTIVITY_INDICATOR_ICON } from "@modules/editor/service/editor.constant.ts";

export function useDynamicLinkIcon() {
  const dynamicLinkStore = useDynamicLinkStore();
  const dynamicLinkIcon_introductionIcon = computed(() => {
    const icon = LESSON_ACTIVITY_INDICATOR_ICON.INTRODUCTION;
    return dynamicLinkStore?.getShowCover ? icon.VIEWABLE : icon.HIDDEN;
  });
  const dynamicLinkIcon_sectionIcon = computed(() => {
    const icon = LESSON_ACTIVITY_INDICATOR_ICON.SECTION;
    return dynamicLinkStore?.getShowSectionCover ? icon.VIEWABLE : icon.HIDDEN;
  });
  const dynamicLinkIcon_pageIcon = ACTIVITY_ICON_NAME.PAGINATION;
  const dynamicLinkIcon_hideSectionActivityNumber = computed(
    () => !dynamicLinkStore.getShowSectionActivityNumber,
  );
  const dynamicLinkIcon_activityIcon = (type: string, optional: boolean) => {
    if (type === LESSON_ACTIVITY_TYPE.ACTIVITY_QUIZ) {
      return optional ? ACTIVITY_ICON_NAME.QUIZ_OPTIONAL : ACTIVITY_ICON_NAME.QUIZ_PAGE;
    } else {
      return optional ? ACTIVITY_ICON_NAME.PAGE_OPTIONAL : ACTIVITY_ICON_NAME.PAGE;
    }
  };

  function dynamicLinkIcon_parseSectionIconLetter(sectionPageNo: number) {
    return StringUtils.getAlphabeticalLetter(sectionPageNo - 1);
  }

  return {
    dynamicLinkIcon_introductionIcon,
    dynamicLinkIcon_sectionIcon,
    dynamicLinkIcon_pageIcon,
    dynamicLinkIcon_hideSectionActivityNumber,
    dynamicLinkIcon_activityIcon,
    dynamicLinkIcon_parseSectionIconLetter,
  };
}
